import React, { Component } from "react"
import { Button } from "reactstrap"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
  Container,
  Row,
  Col,
  Modal,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import WebsiteList from "./List";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

// Utilities
import {
  createNotificationHelpers,
  loadReferenceStoreData,
  createReferenceStore as createReferenceStoreAPI,
  updateReferenceStore as updateReferenceStoreAPI,
  deleteReferenceStore,
  transformReferenceStoresToTableData,
  REFERENCE_STORE_TABLE_COLUMNS,
  MESSAGES
} from "../utils";

class ScannerWebsite extends Component {
  constructor(props) {
    super(props)
    this.state = {
      TotalCustomers: 0,
      CustomersDetails: 0,
      loading: false,
      modal_standard_create: false,
      modal_standard_edit: false,
      id: "",
      p_store: "",
      c_store: "",
      created_at: "",
      updated_at: "",
      is_active: true,
      stores: [],
      parent_store: [],
    }

    // Initialize notification helpers
    const notifications = createNotificationHelpers();
    this.notify_info = notifications.notify_info;
    this.notify_error = notifications.notify_error;
    this.notify_success = notifications.notify_success;
  }

  /**
   * Loads reference stores and related data from API
   */
  loadReferenceStores = async () => {
    const data = await loadReferenceStoreData(this.notify_error);

    if (data) {
      this.setState({
        stores: data.stores,
        parent_store: data.parent_store
      });

      if (data.referenceStores) {
        const records = transformReferenceStoresToTableData(
          data.referenceStores,
          REFERENCE_STORE_TABLE_COLUMNS,
          this.edit_scanner_website,
          this.delete_scanner_website
        );

        this.setState({
          TotalCustomers: data.referenceStores.length,
          CustomersDetails: records,
          loading: true
        });

        this.notify_success(MESSAGES.REFERENCE_STORE_LOADED_SUCCESS);
      }
    }
  }

  componentDidMount() {
    this.loadReferenceStores();
  }

  /**
   * Opens the create reference store modal
   */
  reference_store = () => {
    this.setState(prevState => ({
      p_store: "",
      c_store: "",
      created_at: "",
      updated_at: "",
      modal_standard_create: !prevState.modal_standard_create,
    }))
  }

  /**
   * Deletes a reference store
   */
  delete_scanner_website = async (id) => {
    const success = await deleteReferenceStore(id, this.notify_success, this.notify_error);

    if (success) {
      window.location.reload();
    }
  }

  /**
   * Opens the edit reference store modal
   */
  edit_scanner_website = (id, p_store, c_store, created_at, updated_at) => {
    this.setState(prevState => ({
      id,
      p_store,
      c_store,
      created_at,
      updated_at,
      modal_standard_edit: !prevState.modal_standard_edit,
    }))
  }

  /**
   * Handles input changes in forms
   */
  handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "is_active") {
      this.setState({ [name]: !this.state[name] });
    } else {
      this.setState({ [name]: value });
    }
  }

  /**
   * Creates a new reference store
   */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { p_store, c_store, is_active } = this.state;

    const success = await createReferenceStoreAPI(
      { p_store, c_store, is_active },
      this.notify_error
    );

    if (success !== null) {
      this.setState({ modal_standard_create: false });
      this.notify_success(MESSAGES.REFERENCE_STORE_CREATED_SUCCESS);
      window.location.reload();
    }
  }

  /**
   * Updates an existing reference store
   */
  updateReferenceStore = async (e) => {
    e.preventDefault();
    const { id, p_store, c_store, is_active } = this.state;

    const success = await updateReferenceStoreAPI(
      { id, p_store, c_store, is_active },
      this.notify_error
    );

    if (success !== null) {
      this.setState({ modal_standard_edit: false });
      this.notify_success(MESSAGES.REFERENCE_STORE_UPDATED_SUCCESS);
      window.location.reload();
    }
  }

  /**
   * Renders the action header with create button
   */
  renderActionHeader = () => {
    return (
      <div className="" style={{ textAlign: "right", paddingBottom: "5px" }}>
        <span className="loading"></span>
        <Button
          color="primary"
          className="btn btn-primary waves-effect waves-light"
          onClick={this.reference_store}
          data-toggle="modal"
          data-target="#myModal"
        >
          Create
        </Button>
      </div>
    );
  }

  render() {
    const { CustomersDetails, loading } = this.state;
    const { t } = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <Helmet>
            <title>Veeper | AP - Coupon Scanner Store</title>
          </Helmet>
          <Container fluid>
            <Breadcrumbs
              title={t("Store")}
              breadcrumbItem={t("Reference Store")}
            />
            <ToastContainer />
            <Row>
              <Col xl={12}>
                {loading ? (
                  <React.Fragment>
                    {this.renderActionHeader()}
                    <WebsiteList customers={CustomersDetails} />
                  </React.Fragment>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
                    <Spinner color="primary" />
                    <span style={{ marginLeft: '10px' }}>Loading ...</span>
                  </div>
                )}
              </Col>
            </Row>
            <Modal
              isOpen={this.state.modal_standard_create}
              toggle={this.reference_store}
              size='lg'
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Create Reference Store
                </h5>
                <button
                  type="button"
                  onClick={() =>
                    this.setState({ modal_standard_create: false })
                  }
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <Card>
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Parent Store
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="select"
                            name="p_store"
                            className="form-control"
                            id="horizontal-name-Input"
                            onChange={this.handleInputChange}
                            required
                          >
                            <option value="">Select Store</option>
                            {this.state.parent_store.map((data, index) => (
                              <option key={index} value={data.store}>
                                {data.domain} - {data.store}
                              </option>
                            ))}
                          </Input>
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Child Store
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="select"
                            name="c_store"
                            className="form-control"
                            id="horizontal-icon-Input"
                            onChange={this.handleInputChange}
                          >
                            <option value="">Select Store</option>
                            {this.state.stores.map((store) => (
                              <option key={store.id} value={store.store_domain}>
                                {store.store_domain}
                              </option>
                            ))}
                          </Input>
                        </Col>
                      </FormGroup>

                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Status
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="checkbox"
                            name="is_active"
                            placeholder="Status"
                            className="form-control"
                            id="horizontal-is_active-Input"
                            value={Boolean(this.state?.is_active)}
                            onChange={this.handleInputChange}
                            checked={Boolean(this.state?.is_active)}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup className="row justify-content-end">
                        <Col sm={9}>
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="w-md"
                            >
                              Submit
                            </Button>
                          </div>
                        </Col>
                      </FormGroup>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Modal
              isOpen={this.state.modal_standard_edit}
              toggle={this.edit_scanner_website}
              size='lg'
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                  Edit Reference store
                </h5>
                <button
                  type="button"
                  onClick={() =>
                    this.setState({ modal_standard_edit: false })
                  }
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <Card>
                  <CardBody>
                    <Form onSubmit={this.updateReferenceStore}>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-name-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Parent Store
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="select"
                            name="p_store"
                            className="form-control"
                            id="horizontal-name-Input"
                            onChange={this.handleInputChange}
                            required
                          >
                            <option value="">Select Store</option>
                            {this.state.parent_store.map((data, index) => (
                              <option key={index} value={data.store} selected={data.store === this.state.p_store}>
                                {data.domain} - {data.store}
                              </option>
                            ))}
                          </Input>
                        </Col>
                      </FormGroup>
                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-handle-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Child Store
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="select"
                            name="c_store"
                            className="form-control"
                            id="horizontal-icon-Input"
                            onChange={this.handleInputChange}
                          >
                            <option value="">Select Store</option>
                            {this.state.stores.map((store) => (
                              <option key={store.id} value={store.store_domain} selected={store.store_domain === this.state.c_store}>
                                {store.store_domain}
                              </option>
                            ))}
                          </Input>
                        </Col>
                      </FormGroup>

                      <FormGroup className="row mb-4">
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Status
                        </Label>
                        <Col sm={8}>
                          <Input
                            type="checkbox"
                            name="is_active"
                            placeholder="Status"
                            className="form-control"
                            id="horizontal-is_active-Input"
                            value={Boolean(this.state?.is_active)}
                            onChange={this.handleInputChange}
                            checked={Boolean(this.state?.is_active)}
                          />
                        </Col>
                      </FormGroup>

                      <FormGroup className="row justify-content-end">
                        <Col sm={9}>
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="w-md"
                            >
                              Update
                            </Button>
                          </div>
                        </Col>
                      </FormGroup>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>
          </Container>
        </div>

      </React.Fragment>
    )

  }
}

ScannerWebsite.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(ScannerWebsite)
